import FaqSearch from './faq-search';

export default FaqSearch;
